import { useMassActionsContext } from '@components/MassActions/contexts/MassActions.context';
import { useListMassActions } from '@components/MassActions/hooks/useListMassActions';
import { isParent } from '../../../../../components/ListV2/components/table/virtualizedTable.utils';
import { OrderListMassActionsEnum } from '../../../actions/utils/orderListMassActions';
import useOrderListMassActions from '../../../list/mass-actions/hooks/useOrderListMassActions';
import { OrderListWithBaseItem } from '../../../order.types';
import { UseOrderListPageMassActionsParams } from '../orderListPage.types';

export const useOrderListPageMassActions = ({
  list,
  selectedTab,
  isArchivedOrderFilterActive,
  totalResults,
  isOfflineMode = false,
}: UseOrderListPageMassActionsParams) => {
  const { toggleListItems, massActionFilter } = useMassActionsContext();

  const massActionsState = useOrderListMassActions({
    isOfflineMode,
    listItems: list.state.items,
    selectedIds: list.state.selecteds,
    selectedTab,
    isArchivedOrderFilterActive,
  });

  const hasSelectedEveryListItem =
    list.state.selecteds.length > 0 &&
    list.state.items?.filter((item, index) => !isParent(item, list.state.items[index + 1]))
      .length === list.state.selecteds.length;

  const isAllItemsSelected = hasSelectedEveryListItem || !!massActionFilter;

  useListMassActions<OrderListMassActionsEnum, OrderListWithBaseItem>({
    list,
    actions: massActionsState.massActions,
    onClickAction: massActionsState.handleClickMassAction,
    totalResults,
    isAllSelected: isAllItemsSelected,
    toggleAllSelected: massActionFilter
      ? toggleListItems
      : () => list.checkbox.toggleSelectAllWithParents(),
  });

  return { massActionsState, isAllItemsSelected };
};
